import {
  animate,
  keyframes,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  HostListener,
  Input,
  ElementRef,
  OnDestroy,
  AfterViewChecked,
  AfterViewInit,
  QueryList,
  Renderer2,
  ViewChildren,
} from '@angular/core';
import { NavigationEnd, Router, UrlTree } from '@angular/router';

import { combineLatest, filter } from 'rxjs';
import { CommonService } from 'src/app/shared/service/common.service';
import {
  fadeInOut,
  INavbarData,
  Vehicles,
  VehicleType,
  VehicleTypeCode,
} from './sidenav.interface';
import { UtilService } from '../../services/util.service';
import { VEHICLE_IMG, hideShow } from './nav-data';
import { AuthenticationService } from 'src/app/shared/service/authentication.service';
import {
  LISTS,
  MAPS,
  SYNOPSIS,
  TRACE,
} from 'src/app/shared/routeLink.constant';
import { COMMON_SVG_IMG_PATH } from 'src/app/shared/common.constant';
import { AuthService } from '../../services/auth.service';
import { Store } from '@ngrx/store';
import { logout, updateSelectedVehicle } from 'src/app/store/user/user.actions';
import {
  selectSelectedVehicle,
  selectUserEmail,
  selectUserRole,
  selectVehicleTypes,
} from 'src/app/store/user/user.selectors';
import { selectUserMenuList } from 'src/app/store/userMenuList/userMenuList.selector';
import { LoadUserMenuList } from 'src/app/store/userMenuList/userMenuList.action';
import { selectUser } from 'src/app/store/user/user.selectors'; // add to existing selector imports
import { MY_PROFILE, PROFILE } from 'src/app/shared/routeLink.constant'; // add new import

interface SideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: false,
  animations: [
    fadeInOut,
    hideShow,
    trigger('rotate', [
      transition(':enter', [
        animate(
          '1000ms',
          keyframes([
            style({ transform: 'rotate(0deg)', offset: '0' }),
            style({ transform: 'rotate(2turn)', offset: '1' }),
          ])
        ),
      ]),
    ]),
  ],
})
export class SidenavComponent
  implements OnInit, AfterViewChecked, OnDestroy, AfterViewInit
{
  readonly synopsisRoute = SYNOPSIS;
  showProfileDropdown = false;

  @ViewChildren('closedSubmenu')
  closedSubmenuEls!: QueryList<ElementRef<HTMLDivElement>>;

  @Output() eventToggleSideNav: EventEmitter<SideNavToggle> =
    new EventEmitter();
  screenWidth = 0;
  navData: any;
  multiple = false;
  showMenuIcon = false;
  @Input() collapsed = true;
  @Input() data: any;
  usercode: any;
  rolename: any;
  vehicleType!: VehicleType[];
  filteredVehicles!: any[];
  isVehicleSelect = false;
  vehicleIcon!: string;
  defaultIcon!: string;
  allVehicles!: Vehicles[];
  defaultCode!: any;
  svgPath: string = COMMON_SVG_IMG_PATH;
  openedIndexSubMenu: any = -1;
  openCloseDuration: any = undefined;
  selectedVehicleObj: any;
  currentUrl: any;
  activeMenuCode: string | null = null;
  private closedSubmenuRafId: number | null = null;
  titleName = '';
  showLogoutFlag = true;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 768) {
      this.collapsed = false;
      this.utilService.isMenuCollapsed.next(this.collapsed);
      this.eventToggleSideNav.emit({
        collapsed: this.collapsed,
        screenWidth: this.screenWidth,
      });
    }
    this.scheduleClosedSubmenuViewportAdjust();
  }

  constructor(
    public router: Router,
    private readonly authService: AuthService,
    private readonly elRef: ElementRef,
    private readonly renderer: Renderer2,
    private readonly commonService: CommonService,
    private readonly utilService: UtilService,
    private readonly AuthenticationService: AuthenticationService,
    private readonly store: Store
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          this.updateActiveLinks();
        }, 100);
      }
    });
  }

  ngOnInit(): void {
    // get user code from store
    this.store.select(selectUserEmail).subscribe((email) => {
      this.usercode = email ?? '';
    });
    // get role name from store
    this.store.select(selectUserRole).subscribe((role) => {
      this.rolename = role ? role.name : '';
    });
    // get vehicle type from store
    this.store.select(selectVehicleTypes).subscribe((vehicleTypes) => {
      this.vehicleType = vehicleTypes;
    });
    // get selected vehicle from local storage
    this.store.select(selectSelectedVehicle).subscribe((vehicle) => {
      this.selectedVehicleObj = vehicle || this.vehicleType[0];
    });

    this.store.select(selectUserMenuList).subscribe((menuList) => {
      this.navData = this.buildNavData(menuList);
      this.updateActiveMenuFromUrl(this.router.url);
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateActiveMenuFromUrl(this.router.url);
      });

    this.screenWidth = window.innerWidth;

    this.allVehicles = this.vehicleType.map((vehicle: any) => {
      return {
        ...vehicle,
        icon: this.getIcon(vehicle),
      };
    });

    this.defaultIcon =
      this.commonService.getlocalStorageItem('defaultIcon') ?? '';
    this.defaultIcon =
      this.allVehicles.find(
        (vehicle: any) => vehicle.name === this.selectedVehicleObj?.name
      )?.icon ?? '';
    this.vehicleIcon = this.defaultIcon;
    this.defaultCode = this.allVehicles.find(
      (vehicle: any) => vehicle.name === this.selectedVehicleObj?.name
    )?.code;

    this.filteredVehicles = [...this.allVehicles];
    this.AuthenticationService.currentAuthStatus.subscribe((user) => {
      if (user) {
        this.loadUserData();
        this.screenWidth = window.innerWidth;
      }
    });
    this.toggleCollapse();
    const impersonate = localStorage.getItem('impersonate') === 'true';
    this.showLogoutFlag = !impersonate;
    this.getUserProfile();
  }

  loadUserData(): void {
    combineLatest([
      this.store.select(selectUserEmail),
      this.store.select(selectUserRole),
      this.store.select(selectVehicleTypes),
      this.store.select(selectUserMenuList),
    ]).subscribe(([email, role, vehicleTypes, menuList]) => {
      this.usercode = email ?? '';
      this.rolename = role ? role.name : '';
      this.vehicleType = vehicleTypes;

      this.navData = this.buildNavData(menuList);

      this.processVehicles();
    });
  }

  private processVehicles(): void {
    this.allVehicles = this.vehicleType.map((vehicle: any) => ({
      ...vehicle,
      icon: this.getIcon(vehicle),
    }));

    this.defaultIcon =
      this.commonService.getlocalStorageItem('defaultIcon') ?? '';

    this.defaultIcon =
      this.allVehicles.find(
        (v: any) => v.name === this.selectedVehicleObj?.name
      )?.icon ?? '';

    this.vehicleIcon = this.defaultIcon;

    this.defaultCode = this.allVehicles.find(
      (v: any) => v.name === this.selectedVehicleObj?.name
    )?.code;

    this.filteredVehicles = [...this.allVehicles];
  }

  updateActiveMenuFromUrl(currentUrl: string): void {
    for (const menu of this.navData) {
      if (this.isSynopsisMenu(menu) && currentUrl.includes(`/${SYNOPSIS}`)) {
        this.activeMenuCode = menu.menu_code;
        return;
      }

      for (const subMenu of menu.items ?? []) {
        if (currentUrl.includes(subMenu.route_link)) {
          this.activeMenuCode = menu.menu_code;
          return;
        }
      }
    }
    this.activeMenuCode = null; // If no sub-menu matches
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.updateActiveLinks();
    }, 0);

    this.closedSubmenuEls.changes.subscribe(() => {
      this.scheduleClosedSubmenuViewportAdjust();
    });
  }

  ngAfterViewChecked() {
    this.updateFilteredVehicles();
  }

  getSvgPath() {
    this.svgPath = this.commonService.getSelectedLobPath();
    return this.svgPath;
  }

  loadMenuLinks(vehicleCode: string) {
    this.utilService.loadMenuLinks(vehicleCode).subscribe({
      next: (navData: any) => {
        this.navData = navData;
        this.store.dispatch(LoadUserMenuList({ menu: navData }));
        this.homeNavigate();
      },
      error: (error) => {
        this.utilService.logoutApi().subscribe((ele: any) => {
          this.commonService.clearLocalStorageItems();
          this.store.dispatch(logout());
          sessionStorage.clear();
          this.utilService.redirectToLogin();
        });
      },
    });
    setTimeout(() => {
      this.updateActiveLinks();
    }, 1000);
  }

  toggleCollapse(): void {
    this.collapsed = !this.collapsed;
    this.utilService.isMenuCollapsed.next(this.collapsed);
    this.isVehicleSelect = false;

    if (!this.collapsed) {
      this.closeAllSubMenus();
    }

    this.eventToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  private closeAllSubMenus(): void {
    this.openedIndexSubMenu = -1;
    this.navData?.forEach((menu: any) => {
      menu.expanded = false;
    });
  }

  navigateSynopsis(): void {
    this.closeAllSubMenus();
    this.router.navigateByUrl(`/${SYNOPSIS}`);
  }

  closeSidenav(): void {
    this.collapsed = false;
    this.eventToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  handleClick(item: INavbarData): void {
    item.expanded = !item.expanded;

    this.shrinkItems(item);
    if (this.isVehicleSelect) {
      item.expanded = false;
    }
    if (item.expanded) {
      this.isVehicleSelect = false;
    }
    this.scheduleClosedSubmenuViewportAdjust();
  }

  subMenuClick(item: INavbarData): void {
    this.navData.forEach((menu: INavbarData) => {
      menu.expanded = false;
    });

    // setting state for mapview and list view
    if (item.route_link == `${TRACE}/${LISTS}`) {
      this.utilService.updateViewType(LISTS);
    }
    if (item.route_link == `${TRACE}/${MAPS}`) {
      this.utilService.updateViewType(MAPS);
    }

    //update the status to all if user is not click on mapview or listview

    if (
      item.route_link != `${TRACE}/${LISTS}` &&
      item.route_link != `${TRACE}/${MAPS}`
    ) {
      this.utilService.updateVehicleLegendStatus('All');
    }
  }

  onVehicleClick(vehicle: any): void {
    if (this.selectedVehicleObj?.name !== vehicle.name) {
      this.selectedVehicleObj = vehicle;
      this.updateFilteredVehicles();
    }
    this.defaultIcon = vehicle.icon;
    this.vehicleIcon = this.defaultIcon;
    this.store.dispatch(
      updateSelectedVehicle({
        vehicle: {
          name: this.selectedVehicleObj.name,
          code: this.selectedVehicleObj.code,
          id: this.selectedVehicleObj.id,
        },
      })
    );
    this.isVehicleSelect = false;

    this.loadMenuLinks(vehicle.code);
  }

  toggleVehicleSelect(): void {
    this.isVehicleSelect = !this.isVehicleSelect;
    this.handleClick(this.navData);
  }

  updateFilteredVehicles(): void {
    this.filteredVehicles = this.allVehicles.filter(
      (item: any) => item.name !== this.selectedVehicleObj?.name
    );
  }

  getIcon(data: any, userClick = ''): string {
    this.defaultIcon = data.icon;
    if (userClick == 'click') {
      this.filteredVehicles = this.allVehicles.filter(
        (item: any) => item.name !== data.name
      );
      this.store.dispatch(
        updateSelectedVehicle({
          vehicle: {
            name: data.name,
            code: data.code,
            id: data.id,
          },
        })
      );
      this.loadMenuLinks(data.code);
    }
    this.isVehicleSelect = false;
    const idxForicon: any = VehicleTypeCode[data.code];
    this.vehicleIcon = VEHICLE_IMG[idxForicon];
    return this.vehicleIcon;
  }

  updateActiveLinks() {
    const currentRoute = this.router.url;
    const currentFirstSegment = currentRoute.split('/')[1];

    const getFirstSegment = (route: string | UrlTree): string => {
      const routeStr = typeof route === 'string' ? route : route.toString();
      return routeStr.split('/')[0];
    };

    this.navData?.forEach((menu: any) => {
      menu.isActive = false;

      if (this.isSynopsisMenu(menu)) {
        menu.isActive = currentFirstSegment === SYNOPSIS;
        return;
      }

      if (menu.items?.length) {
        menu.isActive = menu.items.some(
          (subItem: { route_link: string | UrlTree }) =>
            currentFirstSegment === getFirstSegment(subItem.route_link)
        );
      } else if (menu.route_link) {
        menu.isActive =
          currentFirstSegment === getFirstSegment(menu.route_link);
      }
    });
  }

  shrinkItems(item: INavbarData): void {
    if (!this.multiple) {
      for (const modelItem of this.navData as any[]) {
        if (item !== modelItem && modelItem.expanded) {
          modelItem.expanded = false;
        }
      }
    }
  }

  logout() {
    this.utilService.logoutApi().subscribe((ele) => {
      this.commonService.clearLocalStorageItems();
      this.store.dispatch(logout());
      sessionStorage.clear();
      this.utilService.redirectToLogin();
    });
  }

  homeNavigate() {
    if (this.authService.isScreenAccess(this.router.url, this.navData)) {
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } else {
      this.router.navigate(['']);
    }
  }

  toggleProfileDropdown() {
    this.showProfileDropdown = !this.showProfileDropdown;
  }

  getImageSrc(data: any): string {
    return `${this.svgPath}sprite.svg#${data}`;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elRef.nativeElement.contains(event.target) && this.navData) {
      this.isVehicleSelect = false;
      this.showProfileDropdown = false; // NEW — closes profile dropdown on outside click too
      this.navData.forEach(
        (data: { items: string | any[]; expanded: boolean }) => {
          if (data.items && data.items.length > 0) {
            data.expanded = false;
          }
        }
      );
    }
  }

  showSubMenu(index: any) {
    this.openCloseDuration = 50 * this.navData[index].items.length;
    if (this.openedIndexSubMenu == index) {
      this.openedIndexSubMenu = -1;
      return;
    }
    this.openedIndexSubMenu = index;
  }

  isOpened(l: any) {
    return true;
  }

  iconExtension(iconName: any) {
    return this.svgPath + this.selectedVehicleObj?.name + '.svg';
  }

  ngOnDestroy() {
    if (this.closedSubmenuRafId !== null) {
      cancelAnimationFrame(this.closedSubmenuRafId);
      this.closedSubmenuRafId = null;
    }
    this.collapsed = true;
    this.eventToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  //for automatic adjustment of closed submenu within viewport on scroll and resize
  private scheduleClosedSubmenuViewportAdjust(): void {
    if (this.closedSubmenuRafId !== null) {
      cancelAnimationFrame(this.closedSubmenuRafId);
    }

    this.closedSubmenuRafId = requestAnimationFrame(() => {
      this.closedSubmenuRafId = null;
      this.adjustClosedSubmenuWithinViewport();
    });
  }

  private adjustClosedSubmenuWithinViewport(): void {
    const el = this.closedSubmenuEls?.first?.nativeElement;
    if (!el) return;

    const viewportPaddingPx = 8;
    const maxHeightPx = Math.max(0, window.innerHeight - viewportPaddingPx * 2);

    // Reset before measuring (getBoundingClientRect includes transforms).
    this.renderer.setStyle(el, 'transform', '');
    this.renderer.setStyle(el, 'max-height', `${maxHeightPx}px`);
    this.renderer.setStyle(el, 'overflow-y', 'auto');

    const rect = el.getBoundingClientRect();
    const overflowBottomPx =
      rect.bottom - (window.innerHeight - viewportPaddingPx);

    let translateYPx = 0;
    if (overflowBottomPx > 0) {
      translateYPx = -overflowBottomPx;
      const newTop = rect.top + translateYPx;
      if (newTop < viewportPaddingPx) {
        translateYPx += viewportPaddingPx - newTop;
      }
    }

    if (translateYPx !== 0) {
      this.renderer.setStyle(el, 'transform', `translateY(${translateYPx}px)`);
    }
  }

  getUserProfile(): void {
    this.store.select(selectUser).subscribe((user) => {
      this.titleName = user?.name ?? '';
    });
  }

  isSynopsisMenu(menu: INavbarData): boolean {
    return menu.menu_name?.trim().toLowerCase() === 'synopsis';
  }

  isSynopsisCatalogueMenu(menu: INavbarData): boolean {
    return (
      this.isSynopsisMenu(menu) &&
      (menu.items?.some((item) => this.isCatalogueReportItem(item)) ?? false)
    );
  }

  private buildNavData(menuList: any[] = []): INavbarData[] {
    return (Array.isArray(menuList) ? menuList : []).map((menu) => {
      const items =
        menu.items?.map((sub: INavbarData) => ({
          ...sub,
          expanded: false,
        })) ?? [];

      // Catalogue Report is a mode marker, not a normal submenu entry.
      const visibleItems = this.isSynopsisMenu(menu)
        ? items.filter((item: INavbarData) => !this.isCatalogueReportItem(item))
        : items;

      return {
        ...menu,
        expanded: false,
        // Keep the marker on catalogue-mode menus so the template can select
        // the direct catalogue link without rendering it as a child.
        items:
          this.isSynopsisMenu(menu) && visibleItems.length !== items.length
            ? [
                ...visibleItems,
                ...items.filter((item: INavbarData) =>
                  this.isCatalogueReportItem(item)
                ),
              ]
            : visibleItems,
      };
    });
  }

  private isCatalogueReportItem(item: INavbarData): boolean {
    return item.sub_menu_name?.trim().toLowerCase() === 'catalogue';
  }

  // ...add this new method:
  navigateProfile(): void {
    this.showProfileDropdown = false;
    this.router.navigateByUrl(`/${PROFILE}/${MY_PROFILE}`);
  }

  // end of closed submenu adjustment code
}
